export const filterCommonSkus = (recommended, reference) => {
  // Create a Set of recommended items with a unique key based on sku and plant
  const referenceSet = new Set(recommended.map((item) => `${item.sku}-${item.plant}`));

  // Filter reference items based on existence in referenceSet
  const filteredReference = reference.filter(
    (recItem) => !referenceSet.has(`${recItem.sku}-${recItem.plant}`),
  );

  // Keep only the common elements in recommended
  const commonRecommended = recommended.filter((refItem) =>
    referenceSet.has(`${refItem.sku}-${refItem.plant}`),
  );

  return {
    recommended: commonRecommended,
    reference: filteredReference,
  };
};

export const getAccordionTitle = (data, plant) => {
  if (!data) return 'N/A';
  return `${data.sku} | ${data.sku_description} | ${plant}`;
};

export const filterUniqueSkus = (referenceSkus) => {
  const uniqueSet = new Set();
  return referenceSkus.filter(({ plant, sku }) => {
    const combination = `${plant}_${sku}`;
    if (uniqueSet.has(combination)) {
      return false;
    }
    uniqueSet.add(combination);
    return true;
  });
};

export const getSelectedPlants = (data) => {
  const result = {};

  data.forEach((item) => {
    const {
      production_plant_id,
      secondary_reference_sku,
      secondary_reference_sku_plant,
      primary_reference_sku,
      primary_reference_sku_plant,
    } = item;

    // Create the `selectedData` object
    const selectedData = {};

    // Add recommended SKU if both secondary_reference_sku and secondary_reference_sku_plant are present
    if (secondary_reference_sku && secondary_reference_sku_plant) {
      selectedData[`${secondary_reference_sku}_${secondary_reference_sku_plant}`] = true;
    }

    // Add reference SKU if both primary_reference_sku and primary_reference_sku_plant are present
    if (primary_reference_sku && primary_reference_sku_plant) {
      selectedData[`${primary_reference_sku}_${primary_reference_sku_plant}`] = true;
    }

    // Add or update the result object with the production plant ID as the key
    result[production_plant_id] = {
      selectedData,
    };
  });

  return result;
};

export const isDualRefSku = (type) => {
  return type === 'dual';
};

const destructureSelectedSkuPlant = (data) => {
  let sku,
    plant = null;
  Object.keys(data || {}).forEach((key, index) => {
    const parts = key.split('_');
    if (index === 0) {
      sku = parts[0];
      plant = parts[1];
    }
  });

  return { sku, plant };
};

const getRefSku = (primary, secondary = null) => {
  if (secondary) {
    const primaryRefData = destructureSelectedSkuPlant(primary.selectedData);
    const secondaryRefData = destructureSelectedSkuPlant(secondary.selectedData);
    return {
      sku_id: primary.sku_id,
      primary_reference_sku: primaryRefData.sku,
      primary_reference_sku_plant: primaryRefData.plant,
      secondary_reference_sku: secondaryRefData.sku,
      secondary_reference_sku_plant: secondaryRefData.plant,
      production_plant_id: primary.production_plant_id,
    };
  } else {
    const refData = destructureSelectedSkuPlant(primary.selectedData);

    return {
      sku_id: primary.sku_id,
      primary_reference_sku: refData.sku,
      primary_reference_sku_plant: refData.plant,
      secondary_reference_sku: null,
      secondary_reference_sku_plant: null,
      production_plant_id: primary.production_plant_id,
    };
  }
};

export const makePayload = (plants, singleRefSku, brewing, packaging) => {
  const payload = [];
  plants.forEach(({ id, type_of_ref_sku }) => {
    if (isDualRefSku(type_of_ref_sku)) {
      const sku = getRefSku(brewing[id], packaging[id]);
      payload.push(sku);
    } else {
      const sku = getRefSku(singleRefSku[id]);
      payload.push(sku);
    }
  });

  return payload;
};

export const getPlants = (plants) =>
  plants.reduce((acc, plant) => ({ ...acc, [plant.id]: {} }), {});

export const previewOnly = (skus) => skus.length > 0;
